<div
  class="popover-action-menu__content"
  role="menu"
  [attr.aria-label]="menuAriaLabelKey() ? (menuAriaLabelKey() | translate) : null"
>
  @for (item of visibleItems(); track item.id) {
    <button
      type="button"
      role="menuitem"
      class="popover-action-menu__item"
      [class.popover-action-menu__item--disabled]="item.disabled"
      [disabled]="item.disabled"
      (click)="onMenuItemClick(item)"
    >
      {{ item.labelKey | translate }}
    </button>
  }
</div>
